import * as React from 'react';
import { Component } from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router';
//import { Redirect } from 'react-router';
import './NavMenu.css';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { Hidden } from '@material-ui/core';
import Enrolment from './Enrolment/Enrolment';
import DocumentUpload from './DocumentUpload/DocumentUpload';
import EnrolmentHelp from './Enrolment/EnrolmentHelp';

const drawerWidth = 240;

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    appBar: {
        backgroundColor: theme.palette.primary.main,
        zIndex: theme.zIndex.drawer + 1,
        position: 'absolute',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: '100%',
        },

    },
    appBarTitle: {
        marginLeft: theme.spacing(1),
        color: theme.palette.primary.contrastText,
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawer: {
        flexShrink: 0,
        width: drawerWidth,
        marginTop: '69px'
    },
    drawerPaper: {
        position: 'relative',
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: '93vh',
        marginBottom: '50px',
    },
    container: {
        padding: theme.spacing(0),
        marginTop: theme.spacing(3),
    },
    logo: {

        height: '64px',
        padding: '5px',
        paddingTop: '8px',
    },
    footer: {
        position: "absolute",
        bottom: "0",
        padding: theme.spacing(0),

    },
    footerContainer: {

    },
    alignRight: {
        float: 'right'
    },
    crabText: {
        color: '#36363699',
        fontSize: '12px',
    },
    collegeText: {
        color: '#36363699',
        fontSize: '12px',
        float: 'right',
    },
    crabTextLink: {
        color: '#36363699',
    },
    crabLogo: {
        height: '12px;',
        marginLeft: '4px',
        marginBottom: '-2px'
    },
});

interface INavMenuProps extends WithStyles<typeof styles> {
}

interface INavMenuState {
    anchorEl: HTMLButtonElement | null,
    testDBVal: string
}

export class NavMenu extends Component<INavMenuProps, INavMenuState> {
    constructor(props: INavMenuProps) {
        super(props);

        this.state = {
            anchorEl: null,
            testDBVal: ''
        };
    }

    public componentDidMount() {
        fetch('api/Home/TestDbConection', {
            method: 'GET',
        })
        .then(response => response.text())
        .then((data) => {
            console.log(data);
        });
    }

    public render() {
        const classes = this.props.classes;

        // const QuoteLink = React.forwardRef<HTMLAnchorElement, Omit<LinkProps, 'innerRef' | 'to'>>((props, ref) => (<Link {...props} to="/Quotes" innerRef={ref} />));

        return (
            <div className={classes.root}>
                <AppBar className={classes.appBar} position="fixed">
                    <Toolbar>
                        <Grid container justify="space-around" >
                            <Grid item>
                                <img src="/logo-hcg.png" className={classes.logo} />
                            </Grid>
                        </Grid>
                        <Menu
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.userMenuClose}>
                        </Menu>
                    </Toolbar>
                </AppBar>

                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Container maxWidth="sm" className={classes.container}>

                        <div>
                            <Switch>
                                {/* tslint:disable-next-line  jsx-no-lambda */}
                                <Route exact path='/'>
                                    <DocumentUpload />
                                </Route>

                                {/* tslint:disable-next-line  jsx-no-lambda */}
                                <Route exact path='/Enrolment'>
                                    <Enrolment />
                                </Route>

                                <Route exact path='/Help'>
                                    <EnrolmentHelp />
                                </Route>

                                {/* tslint:disable-next-line  jsx-no-lambda */}
                                <Route exact path='/DocumentUpload'>
                                    <DocumentUpload />
                                </Route>
                            </Switch>
                        </div>
                    </Container>

                </main>

                <Container maxWidth="xl" className={classes.footer}>

                    <Container maxWidth="sm" className={classes.footerContainer}>
                        <hr />
                        <Grid container justify="space-between" spacing={1}>
                            <Grid item xs={12}>
                                <Typography className={classes.crabText} variant="body1">Having trouble? Please contact support at <a className={classes.crabTextLink} href="mailto:enrolment.queries@Hull-College.ac.uk" target="_blank">enrolment.queries@Hull-College.ac.uk</a></Typography>
                            </Grid>
                            <Grid item xs={6} >
                                <Hidden xsDown>
                                    <Typography className={classes.crabText} variant="body1"><a className={classes.crabTextLink} href="https://smashedcrabstudio.com" target="_blank">Built by Smashed Crab Studio</a><img src="/crab.png" className={classes.crabLogo} /></Typography>
                                </Hidden>
                                <Hidden smUp>
                                    <Typography className={classes.crabText} variant="body1"><a className={classes.crabTextLink} href="https://smashedcrabstudio.com" target="_blank">Built by</a><img src="/crab.png" className={classes.crabLogo} /></Typography>
                                </Hidden>
                            </Grid>
                            <Grid item xs={6} >
                                <Typography className={classes.collegeText} variant="body1">Hull College Group</Typography>
                            </Grid>
                        </Grid>
                    </Container>
                </Container>
            </div>
        );
    }


    private userMenuClose = () => {
        this.setState({ anchorEl: null });
    }
}


export default withStyles(styles)(NavMenu);

